"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVirtualPowerPlant = function IconVirtualPowerPlant(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M27 5c6.728 0 11.965 5.324 12.257 12.11l.01.295.118.013c4.692.595 8.358 4.484 8.604 9.33l.01.281a9.52 9.52 0 0 1-9.473 9.243l-.246-.002h-1.32v-2h1.32v.978l.024-.978c4.137.1 7.576-3.163 7.696-7.246a7.87 7.87 0 0 0-7.498-7.676l-.248-.008-.984-.015v-1.597C37.28 11.731 32.801 7 27.003 7a11.35 11.35 0 0 0-9.728 5.555l-.161.28-.735 1.323-.928-1.194A5.07 5.07 0 0 0 11.576 11a5.1 5.1 0 0 0-5.016 5.114 5 5 0 0 0 .05.733l.042.242.13.673-.58.364C3.66 19.727 2.083 22.493 2 25.45a9 9 0 0 0 8.782 8.818l.263.002.01 2C5.044 36.301.12 31.5 0 25.443a11 11 0 0 1 4.32-8.441l.271-.202a8 8 0 0 1-.024-.349l-.007-.34c-.007-3.88 3.103-7.047 7.02-7.11a7.1 7.1 0 0 1 4.292 1.56l.201.167a13.36 13.36 0 0 1 10.59-5.723zM12.89 31.87c0-6.136 4.974-11.11 11.11-11.11s11.11 4.974 11.11 11.11S30.136 42.98 24 42.98s-11.11-4.974-11.11-11.11m20.22 0a9.11 9.11 0 1 0-18.22 0 9.11 9.11 0 0 0 18.22 0m-11.99.97L25 25.08v5.82h1.88L23 38.66v-5.82z",
    clipRule: "evenodd"
  })));
};

export { IconVirtualPowerPlant, IconVirtualPowerPlant as default };
